import React, { Fragment, useCallback } from 'react';
import { Form as FormikForm, Formik, FormikValues, FormikConfig, FormikErrors } from 'formik';
import { BlockWrapper, FormBlock } from '../../types/general';
import * as Schema from '../../types/schema';
import Tabs from './Tabs';
import Row from './Row';
import { FormikReturnProps } from '../../FormViewer';
import DefaultButtonBar from '../../components/ButtonBar/ButtonBar';
import { ConditionWrapper } from '../../app/components/ConditionWrapper';
import './Form.scss';

export interface FormViewerProps extends Omit<FormikConfig<FormikValues>, 'onSubmit'>, FormBlock<Schema.Schema> {
	onInit?: (args: FormBlockOnChange) => void;
	onChange?: (args: FormBlockOnChange) => void;
	onSubmit?: (args: FormBlockOnSubmit) => void;
	onCancelWhenModified?: () => void;
	onSchemaChange?: (args: FormBlockOnSchemaChange) => void;
	onLocaleChange?: (localeKey: string) => void;
	slots?: {
		ButtonBar?: (props: FormProps) => JSX.Element;
	};
}

interface FormBlockOnSubmit extends Omit<FormProps, 'initialValues'> {
	values: FormikValues;
}

interface FormBlockOnChange extends Omit<FormProps, 'initialValues'> {
	values: FormikValues;
	errors: FormikErrors<FormikValues>;
	changedValues: FormikValues;
	setValues: (values: FormikValues) => void;
	setSchema: (schema: Schema.Schema) => void;
	getSchemaNode: (id: string) => Schema.SchemaNode | null;
	setSchemaNode: (id: string, updated: Schema.SchemaNode) => void;
}

interface FormBlockOnSchemaChange {
	schema: Schema.Schema;
}

export const DefaultBlockWrapper: BlockWrapper = ({ children, ...rest }) => {
	return <ConditionWrapper {...rest}>{children}</ConditionWrapper>;
};

export const PropsDriller = (props: FormBlock<any>) => {
	const { components, options, onFieldValidate, onSelectFiles, onDownloadFile, onRemoveFile } = props;
	return { components, options, onFieldValidate, onSelectFiles, onDownloadFile, onRemoveFile };
};

export interface FormProps extends FormViewerProps {
	form: FormikReturnProps;
}

export function Form(props: FormProps): JSX.Element | null {
	const { schema, components, options = {}, slots = {} } = props;
	const { ButtonBar = DefaultButtonBar } = slots;
	const { editMode } = options;
	const tabsCount = schema.tabs ? schema.tabs.length : 0;
	if (tabsCount === 0) {
		return null;
	}
	const drill = PropsDriller(props);
	return (
		<Fragment>
			<Tabs schema={schema} {...drill} />
			{!editMode && <ButtonBar {...props} />}
		</Fragment>
	);
}

export default Form;
